import React, { Component } from 'react'
import { Form, FormField, TextBox, DateBox, ComboBox, Panel, Messager, NumberBox } from 'rc-easyui';
import { getCookie, getAccessToken } from '../../../helpers/cookieHelper';
import { API_URL } from "../../../constants";
import { Button } from 'reactstrap';
import { isEmpty } from "../../../helpers";
import { autoDissaperAction } from "../../../helpers/index";

const axios = require("axios");
class CreateTicketDetail extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoading: false,
    }
  }

  handleSave = async () => {
    let token = getCookie("access_token");
    let tokenType = getCookie("token_type");
    let form = Object.assign({}, this.props.Ticket)
    let apiUrl = `${API_URL}api/saveticket`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    this.props.innerRef.current.validate(async (errors) => {
      if (isEmpty(errors)) {
        //No Form Validation Error
        if (token != null) {
          //Access Token Available
          this.setState({
            isLoading: true,
          });
          axios
            .post(apiUrl, form, headersConfig)
            .then((response) => {
          
              if (response.status === 200) {
                this.setState({
                  isLoading: false,
                });
                if (response.data.status) {
                  this.messager.alert({
                    title: "Success",
                    msg: response.data.message,
                    icon: "info",
                    reload: true,
                    buttons: [
                      {
                        text: "ok",
                        onClick: () => {
                          window.location.reload();
                        },
                      },
                    ],
                  }); // ticket detail  Saved Successfully ie. 200
                  autoDissaperAction();
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: response.data.message,
                  });
                }
                // this.props.formClear();
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Uncaught Error",
                  reload: false,
                });
              }
            })
            .catch((error) => {
              this.setState({
                isLoading: false,
              });
              this.messager.alert({
                title: "Error",
                msg: "Internal Server Error",
                reload: false,
              });
              var response = error["response"];
              if (response !== undefined) {
                if (response.status === 400) {
                  var message = "";
                  response.data.errors.forEach((row, i) => {
                    message +=
                      "<p style='margin-bottom:3px;'>" +
                      row.field.toUpperCase() +
                      " " +
                      row.defaultMessage +
                      "</p>";
                  });
                  this.messager.alert({
                    title: "Error",
                    msg: message,
                    reload: false,
                  }); // Backend Validation Error ie.400
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: "UnCaught Error",
                    reload: false,
                  }); // Uncaught Backend Error ie.500 eyc.
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Internal Server Error",
                  reload: false,
                }); // Caused due to syntax error in front end
              }
            });
        } else {
          //Access Token Expired.
          //Generate new Access Token using Refresh Token.
          const resp = await getAccessToken();
          if (resp) {
            this.handleSave();
          }
        }
      } else {
        //alert("Front End Form Validaion ");
        this.messager.alert({
          title: "Error",
          icon: 'error',
          msg: "Please fill required field.",
          reload: false,
        });
      }
    });

  }










  render() {
    const { Ticket,
      handleInput,
      projectList,
      priorityList,
      ticketTypeList,
      StatusList,
      enableStatus,
      privateTicketStatus,
      operation,
      rules,
      userList
    } = this.props;
    const { isLoading } = this.state;


    return (
      <div>
        <Panel title='Ticket Detail Form' bodyStyle={{ padding: 20 }}>

          <Messager
            className='Notification_Middle'
            ref={(ref) => (this.messager = ref)}
          />
          <div
            className='loadingmodel'
            style={{ display: isLoading ? "block" : "none" }}
          ></div>

          <Form
            ref={this.props.innerRef}
            style={{ maxWidth: 1200 }}
            model={Ticket}
            labelWidth={150}
            labelAlign="left"
            labelPosition='top'
            onChange={handleInput}
            rules={rules}>

            <div>
              <FormField name="summary" label="Summary:">
                <TextBox value={Ticket.summary}></TextBox>
              </FormField>
            </div>
            <div>
              <FormField name="description" label="Description:">
                <TextBox value={Ticket.description}></TextBox>
              </FormField>
            </div>




            <div className="row">
              <div className="col-6">
                <FormField name="linkedTicket" label="Linked Ticket:">
                  <TextBox value={Ticket.linkedTicket}></TextBox>
                </FormField>
              </div>
              <div className="col-6">

                <FormField name="privateTicket" label="Private Ticket:">
                  <ComboBox
                    style={{ width: "100%" }}
                    data={privateTicketStatus}
                    value={Ticket.privateTicket}
                    textField='text'
                  ></ComboBox>
                </FormField>
              </div>
            </div>




            <div className="row">
              <div className="col-6">
                <FormField name="projectId" label="Project Name:">
                  <ComboBox
                    style={{ width: "100%" }}
                    data={projectList}
                    value={Ticket.projectId}
                    valueField="id"
                    textField="projectName"

                  />
                </FormField>
              </div>
              <div className="col-6">
                <FormField name="assigneeId" label="Assignee:">
                  <ComboBox
                    style={{ width: "100%" }}
                    data={userList}
                    value={Ticket.assigneeId}
                    valueField="id"
                    textField="username"

                  />
                </FormField>
              </div>
            </div>





            <div className="row">
              <div className="col-6">
                <FormField name="priorityId" label="Priority:" >
                  <ComboBox
                    style={{ width: "100%" }}
                    data={priorityList}
                    value={Ticket.priorityId}
                    valueField="id"
                    textField="priority"

                  />
                </FormField>
              </div>
              <div className="col-6">
                <FormField name="ticketTypeId" label='Ticket Type:'>
                  <ComboBox
                    style={{ width: "100%" }}
                    data={ticketTypeList}
                    value={Ticket.ticketTypeId}
                    valueField="id"
                    textField="ticketType"

                  />
                </FormField>
              </div>
            </div>



            <div className="row">
              <div className="col-6">
                <FormField name="statusId" label="Ticket Status:">
                  <ComboBox
                    style={{ width: "100%" }}
                    data={StatusList}
                    value={Ticket.statusId}
                    valueField="id"
                    textField="status"
                  />
                </FormField>
              </div>
              <div className="col-6">
                <FormField name="enabled" label="Status:">
                  <ComboBox style={{ width: "100%" }} data={enableStatus} value={Ticket.enabled}></ComboBox>
                </FormField>
              </div>
            </div>





            <div className="row">
              <div className="col-6">

                <FormField name="workLog" label="Worklog:">

                  {/* <TextBox value={Ticket.workLog}
                    placeholder="....hours and ....minutes"
                  ></TextBox> */}
                  <NumberBox value={Ticket.workLog} min={0}>
                  </NumberBox>
                </FormField>
              </div>
              <div className="col-6">
                <FormField name="estimate" label="Estimate Time:">
                  {/* <TextBox value={Ticket.estimate}
                    placeholder="....hours and ....minutes"
                  ></TextBox> */}
                  <NumberBox value={Ticket.estimate} min={0}></NumberBox>
                </FormField>
              </div>

            </div>




            <div >
              <FormField name="expectedCompletionDateAd" label="Expected Completion Date(AD):">
                {/* <MaskedBox inputId="m2" mask="9999-99-99" value={Ticket.expectedCompletionDateAd}  ></MaskedBox> */}
                <DateBox
                  format='yyyy-MM-dd'
                  value={Ticket.expectedCompletionDateAd}
                  panelStyle={{ width: 250, height: 300, margin: "auto" }}
                ></DateBox>
              </FormField>

            </div>
            <div>

              <FormField name="comments" label="Comments:">
                <TextBox multiline style={{height:"100px"}} value={Ticket.comments}></TextBox>
              </FormField>
            </div>



            <div className='text-center'>
              <Button
                color='primary'
                onClick={
                  operation === "Add" ? this.handleSave : this.handleUpdate
                }
                disabled={isLoading ? true : false}

                style={{ marginRight: 20 }}
              >
                {operation === "Add" ? "Save" : "Update"}
              </Button>
              <Button color='danger' onClick={this.props.formClear}>
                Cancel
              </Button>
            </div><br />




          </Form>
        </Panel>
      </div>

    )
  }
}
export default React.forwardRef((props, ref) => (
  <CreateTicketDetail innerRef={ref} {...props} />
))
